import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useConfigContext } from '@/hoc';
import { VoiceChatIcon } from '@/icons/voice-chat-icon';
import { VovIcon2 } from '@/icons/vov-icon-2';
import { VovIcon3 } from '@/icons/vov-icon-3';
import { getToken } from '@/utils';
import { useMemo, useState } from 'react';
import Modal from './modal';
import { Button } from './ui';
const VovSystemHomepage = ({ onCloseCallback }) => {
    const [isOpen, setIsOpen] = useState(false);
    const { config: { icons, externalThemeKey, externalThemeMapping }, } = useConfigContext();
    const externalThemeData = useMemo(() => {
        if (!externalThemeKey)
            return null;
        const themeData = getToken(externalThemeKey);
        if (themeData && typeof themeData === 'string') {
            try {
                return JSON.parse(themeData);
            }
            catch (error) {
                console.error('Failed to parse external theme data:', error);
            }
        }
        return themeData;
    }, [externalThemeKey]);
    // Helper to get nested value by dot-separated path
    const getNestedValue = (obj, path) => {
        if (!obj || !path)
            return undefined;
        return path
            .split('.')
            .reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined), obj);
    };
    const vovExternalTheme = useMemo(() => {
        if (!externalThemeData || !externalThemeMapping)
            return {};
        const result = Object.keys(externalThemeMapping).reduce((acc, key) => {
            acc[key] = undefined;
            return acc;
        }, {});
        Object.entries(externalThemeMapping).forEach(([key, path]) => {
            result[key] = getNestedValue(externalThemeData, path);
        });
        return result;
    }, [externalThemeData, externalThemeMapping]);
    const renderVovIcon = (iconName) => {
        switch (iconName) {
            case 'icon1':
                return _jsx(VoiceChatIcon, {});
            case 'icon2':
                return _jsx(VovIcon2, {});
            case 'icon3':
                return _jsx(VovIcon3, {});
            default:
                return _jsx(VoiceChatIcon, {});
        }
    };
    return (_jsxs("div", { className: 'flex h-full justify-center items-center', children: [!(vovExternalTheme === null || vovExternalTheme === void 0 ? void 0 : vovExternalTheme.vovHide) && (_jsxs(Button, { size: 'sm', variant: 'secondary', className: 'py-2 rounded-lg cursor-pointer transition-colors', style: {
                    background: (vovExternalTheme === null || vovExternalTheme === void 0 ? void 0 : vovExternalTheme.vovBackgroundColor) || 'var(--color-secondary)',
                    width: (vovExternalTheme === null || vovExternalTheme === void 0 ? void 0 : vovExternalTheme.vovWidth) || '40px',
                    height: (vovExternalTheme === null || vovExternalTheme === void 0 ? void 0 : vovExternalTheme.vovHeight) || '40px',
                }, onMouseEnter: (e) => {
                    if (vovExternalTheme === null || vovExternalTheme === void 0 ? void 0 : vovExternalTheme.vovHoverColor) {
                        e.currentTarget.style.background =
                            vovExternalTheme.vovHoverColor;
                    }
                    if (vovExternalTheme === null || vovExternalTheme === void 0 ? void 0 : vovExternalTheme.vovHoverIcon) {
                        const img = e.currentTarget.querySelector('img');
                        if (img)
                            img.src = vovExternalTheme.vovHoverIcon;
                    }
                }, onMouseLeave: (e) => {
                    e.currentTarget.style.background =
                        (vovExternalTheme === null || vovExternalTheme === void 0 ? void 0 : vovExternalTheme.vovBackgroundColor) || 'var(--color-secondary)';
                    if (vovExternalTheme === null || vovExternalTheme === void 0 ? void 0 : vovExternalTheme.vovIconUrl) {
                        const img = e.currentTarget.querySelector('img');
                        if (img)
                            img.src = vovExternalTheme.vovIconUrl;
                    }
                }, onClick: () => setIsOpen(true), children: [(vovExternalTheme === null || vovExternalTheme === void 0 ? void 0 : vovExternalTheme.vovIconUrl) ? (_jsx("img", { src: vovExternalTheme.vovIconUrl, alt: 'VOV Icon', className: 'w-8 h-8', style: {
                            width: (vovExternalTheme === null || vovExternalTheme === void 0 ? void 0 : vovExternalTheme.vovWidth) || '40px',
                            height: (vovExternalTheme === null || vovExternalTheme === void 0 ? void 0 : vovExternalTheme.vovHeight) || '40px',
                        } })) : (renderVovIcon(icons === null || icons === void 0 ? void 0 : icons.vovIcons)), (vovExternalTheme === null || vovExternalTheme === void 0 ? void 0 : vovExternalTheme.vovText) && _jsx("span", { className: 'ml-2', children: vovExternalTheme.vovText })] })), isOpen && (_jsx(Modal, { onClose: () => {
                    onCloseCallback === null || onCloseCallback === void 0 ? void 0 : onCloseCallback();
                    setIsOpen(false);
                } }))] }));
};
export default VovSystemHomepage;
